import React, { useState } from 'react';
import { Link2, Check } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

/**
 * CopyLinkButton — pulsante che copia l'URL corrente (con tutti i query params
 * dei filtri sincronizzati) negli appunti. Feedback visivo per 1.5s.
 */
export function CopyLinkButton({ testId = 'copy-link-btn', label = 'Copia link' }) {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link copiato negli appunti', { description: 'Pronto da incollare via WhatsApp, email o Slack.' });
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Impossibile copiare il link');
    }
  };
  return (
    <Button
      variant="outline"
      size="sm"
      className="rounded-none h-9 px-3 font-normal"
      onClick={onClick}
      data-testid={testId}
      aria-label={label}
    >
      {copied
        ? <><Check className="w-4 h-4 mr-2 text-emerald-600" /> <span className="text-sm">Copiato</span></>
        : <><Link2 className="w-4 h-4 mr-2 text-slate-500" /> <span className="text-sm">{label}</span></>}
    </Button>
  );
}
